<p
  class="mb-3"
  *ngIf="mode === 'unload'">
  Seleziona i seriali da scaricare dal magazzino <strong>{{ warehouse.name }}</strong>. Gli asset
  usciranno dal magazzino e passeranno al cliente finale, all'utilizzatore e alla commessa del
  ticket.
</p>
<p
  class="mb-3"
  *ngIf="mode === 'reserve'">
  Facoltativo: scegli i seriali da riservare alla consegna dal magazzino
  <strong>{{ warehouse.name }}</strong>. Restano in magazzino ma risultano impegnati nella
  consegna, e li evaderai con il DDT. Se non ne scegli nessuno potrai indicarli al momento della
  spedizione.
</p>

<div
  class="grid align-items-center mb-2"
  *ngFor="let r of rows">
  <div class="col-12 md:col-5">
    <p class="font-bold mb-0">{{ r.name }}</p>
    <small class="grey-text block">{{ r.brand }}</small>
    <small class="grey-text block">
      {{ r.stock_type === 1 ? 'Vendita' : 'Manutenzione' }} -
      {{ mode === 'reserve' ? 'seriali da riservare (fino a ' + r.qty + ')' : 'seriali da scegliere: ' + r.qty }}
    </small>
    <small
      class="p-error block"
      *ngIf="mode === 'unload' && !r.loading && availableCount(r) < r.qty">
      Seriali disponibili insufficienti ({{ availableCount(r) }}): serializza la giacenza o libera i
      seriali impegnati prima di scaricare.
    </small>
  </div>
  <div class="col-12 md:col-7">
    <p-multiSelect
      [options]="r.options"
      [formControl]="r.selected"
      optionLabel="label"
      optionValue="serial_number"
      optionDisabled="disabled"
      [selectionLimit]="r.qty"
      [filter]="true"
      display="chip"
      [placeholder]="r.loading ? 'Caricamento...' : 'Scegli i seriali...'"
      selectedItemsLabel="{0} seriali selezionati"
      styleClass="w-full"
      appendTo="body"></p-multiSelect>
  </div>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      icon="pi pi-times"
      (click)="close()"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      type="button"
      [label]="confirmLabel"
      icon="pi pi-check"
      (click)="confirm()"
      styleClass="butt"
      [rounded]="true"
      [disabled]="!canConfirm"></p-button>
  </div>
</div>
